// extracted by mini-css-extract-plugin
export default {"root":"CollectionKits_root__168e7","list":"CollectionKits_list__6BIAz","item":"CollectionKits_item__2iJtk"};